import actionCreatorFactory from 'typescript-fsa';
import { InferenceResultSubdiv } from '../../../models/InferenceResultSubdiv';
import { InferenceAdditionalResultSubdiv } from '../../../models/InferenceAdditionalResultSubdiv';
import { KansatsuKirokuObsrec } from '../../../models/KansatsuKirokuObsrec';
// actionのprefixを設定
const actionCreator = actionCreatorFactory('inference');

const execute = actionCreator.async<
  {
    imageStr: string
  }, // started: parameter type
  {
    results: InferenceResultSubdiv[];
    additionalResult: InferenceAdditionalResultSubdiv;
    coordinatesResults: KansatsuKirokuObsrec['observationsScores'];
    croppedImage: {
      bucket: string;
      key: string;
    }
  }, // done: success type
  {
    error: string
  } // failed: error type
  >('EXECUTE');

const reset = actionCreator('RESET');

export {
  execute,
  reset
};



// WEBPACK FOOTER //
// ./src/redux/modules/inferenceSubdiv/actions.ts